var map = {
	"./awards-cup.png": 405,
	"./contact-details.png": 406,
	"./future-building.gif": 407,
	"./future-building.png": 408,
	"./hobby-heap.png": 409,
	"./jiri-soul-pupils.png": 71,
	"./jiri-soul.png": 410,
	"./octopus-tree.gif": 411,
	"./octopus-tree.png": 412,
	"./spiral-tower.gif": 413,
	"./spiral-tower.png": 414,
	"./technology-forest.png": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;